export const PAYMENT_MAPPER_JRPC_IDENTIFIER = 'PAYMENT_MAPPER_JRPC_IDENTIFIER';
